import styled from "styled-components";

export const StyledWrapper = styled.div`
  .contest-heading {
    color: ${({ theme }) => theme.colors.primaryText};
    ${({ theme }) => theme.fontStyles.MobileHeadlinesH3}

    ${({ theme }) => theme.media.exceptMobile`
      ${({ theme }) => theme.fontStyles.DesktopHeadlinesH3}
    `}
  }

  .reward-tier-panel-amount {
    color: ${({ theme }) => theme.colors.primaryText};
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
  }

  .reward-tier-panel-notes {
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.DesktopLargeBodyCopy}
  }

  .reward-tier-panel-text {
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }

  .reward-tier-panel-icon {
    width: 60px;
    height: 60px;
  }
`;
